var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
  EMAIL: "email",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "approval_status",
    label: "承認状態",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved　// Shōnin sumi
      "申請中",  // Applying // Shinsei-chū
      "差戻"    // Rejected // Kyakka
    ],
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT,
  },
  {
    id: "tab_id",
    label: "tab_id",
    type: types.INPUT,
  },
  {
    id: "ref_id",
    label: "ref_id",
    type: types.INPUT,
  },
  {
    id: "syubetu",
    label: "種別",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "control_number",
    label: "ID",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "toroku_number",
    label: "申請No",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant_label",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver_label",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name_label",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "create_time",
    label: "開始日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "update_time",
    label: "更新日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "licensed_department",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    api:"/master_belongs/list_department",
    import: { enabled: true },
  },
  {
    id: "application_date",
    label: "申請日",
    type: types.DATE_PICKER,
  },
  {
    id: "correspondence_situation",
    label: "対応状況",
    type: types.SELECT_BOX,
    options: ["未対応","差戻","対応完了"],
    import: { enabled: true },
  },
  {
    id: "name",
    label: "ユーザ氏名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "mail_address",
    label: "メールアドレス",
    type: types.EMAIL,
    options: ["@mizuhofg.co.jp","@mizuho-bk.co.jp","@mizuhotb.co.jp"],
    import: { enabled: true },
  },
  {
    id: "user_id",
    label: "ユーザID",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "role",
    label: "役割",
    type: types.SELECT_BOX,
    options: ["ユーザIDオペレーション担当者"],
    import: { enabled: true },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
  {
    id: "record_checked",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },

  {
    id: "status_0",
    label: "状態0",
    type: types.SELECT_BOX,
    options: [
      "申請中", // Applying
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "team_1",
    label: "所属チーム1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_1_selected",
    api_uniq_grouping:true,
    import: { enabled: true }
  },
  {
    id: "approver_1",
    label: "承認者1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_filter_to_other_field:{
      by_field:"team_1",
      compare_api_key:"team",
      filter_data_on_event:"team_1_selected",
    },
    import: { enabled: true },
  },
  {
    id: "status_1",
    label: "状態1",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",   // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "team_2",
    label: "所属チーム2",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_2_selected",
    api_uniq_grouping:true,
    import: { enabled: true },
  },
  {
    id: "approver_2",
    label: "承認者2",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_filter_to_other_field:{
      by_field:"team_2",
      compare_api_key:"team",
      filter_data_on_event:"team_2_selected",
    },
    import: { enabled: true },
  },
  {
    id: "status_2",
    label: "状態2",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "team_3",
    label: "所属チーム3",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_3_selected",
    api_uniq_grouping:true,
    import: { enabled: true },
  },
  {
    id: "approver_3",
    label: "承認者3",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_filter_to_other_field:{
      by_field:"team_3",
      compare_api_key:"team",
      filter_data_on_event:"team_3_selected",
    },
    import: { enabled: true },
  },
  {
    id: "status_3",
    label: "状態3",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "team_4",
    label: "所属チーム4",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_4_selected",
    api_uniq_grouping:true,
    import: { enabled: true },
  },
  {
    id: "approver_4",
    label: "承認者4",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_filter_to_other_field:{
      by_field:"team_4",
      compare_api_key:"team",
      filter_data_on_event:"team_4_selected",
    },
    import: { enabled: true },
  },
  {
    id: "status_4",
    label: "状態4",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "team_5",
    label: "所属チーム5",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_5_selected",
    api_uniq_grouping:true,
    import: { enabled: true },
  },
  {
    id: "approver_5",
    label: "承認者5",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_filter_to_other_field:{
      by_field:"team_5",
      compare_api_key:"team",
      filter_data_on_event:"team_5_selected",
    },
    import: { enabled: true },
  },
  {
    id: "status_5",
    label: "状態5",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
  {
    id: "approver_final",
    label: "最終承認者",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    // api_filter_to_other_field:{
    //   by_field:"team_5",
    //   compare_api_key:"team",
    //   filter_data_on_event:"team_5_selected",
    // },
    import: { enabled: true },
  },
  {
    id: "status_final",
    label: "状態6",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "未承認", // Unapproved
      "差戻",  // Rejected
    ],
    import: { enabled: true },
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_id_approval_history.js